<template>
  <div>
    <v-app-bar flat app color="white">
      <v-btn icon @click="gotoHome">
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <div class="d-flex flex-row align-center">
        <div v-if="Location">
          <div class="text-h5 text-capitalize">{{ Location.name }}</div>
        </div>
        <v-progress-circular v-else indeterminate size="20" color="primary"></v-progress-circular>

        <!-- <v-skeleton-loader type="heading"></v-skeleton-loader> -->
      </div>
      <v-spacer></v-spacer>
      <v-menu v-if="subscription" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small color="primary" dark v-bind="attrs" v-on="on">
            Action
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="hardwareOrder">
            <v-list-item-title>Order Hardware</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <!-- v-if="subscription.status === 'active'" -->
          <UpDateSubscription v-if="subscription.status === 'active'" :subscription="subscription" :location="Location"
            :customer="customer" @update="reload" buttonStyle="list" :upComingInvoice="upComingInvoice">
          </UpDateSubscription>

          <StartSubscription v-if="subscription.status === 'canceled'" :subscription="subscription" :location="Location"
            :customer="customer" @update="reload" :upComingInvoice="upComingInvoice"></StartSubscription>
          <v-divider v-if="subscription.status === 'canceled'"></v-divider>
          <UpdatePayment :locationId="this.Location.id" :subscription="subscription" :customer="customer"
            :defaultCardId="defaultCardId" @update="loadSubscription"></UpdatePayment>

          <v-divider v-if="subscription.status === 'active'"></v-divider>
          <Cancel v-if="subscription.status === 'active'" :subscription="subscription" :location="Location"
            :customer="customer" @subCancel="reload" :upComingInvoice="upComingInvoice"></Cancel>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-divider></v-divider>
    <v-container>
      <!-- <v-row align="center">
        <v-col>
          <div v-if="Location">
            <div class="text-h5">{{ Location.name }}</div>
          </div>
          <div v-else>
            <v-skeleton-loader type="heading"></v-skeleton-loader>
          </div>
        </v-col>
        <v-col class="shrink text-right" cols="3" v-if="subscription">
          <v-chip
            v-if="subscription.status === 'active'"
            label
            small
            color="green lighten-4"
            text-color="green darken-4"
            >Active</v-chip
          >
          <v-chip
            v-if="subscription.status === 'canceled'"
            label
            small
            color="grey lighten-4"
            text-color="grey darken-4"
            >Canceled</v-chip
          >
        </v-col>
        <v-col cols="3" v-else>
          <v-skeleton-loader width="150" type="heading"></v-skeleton-loader>
        </v-col>
      </v-row> -->
      <div v-if="Location">
        <div class="text-caption">{{ Location.Address.addressLine1 }}</div>
        <div class="text-caption" v-if="Location.Address.phoneNumber">
          {{ Location.Address.phoneNumber }}
        </div>
      </div>
      <v-skeleton-loader v-else class="mt-2" width="250" type="text@2"></v-skeleton-loader>

      <v-row class="mt-3 mb-1">
        <v-col class="title">Subscription Detail</v-col>
        <v-col class="text-right shrink" v-if="subscription">
          <v-chip v-if="subscription.status === 'active'" label small color="green lighten-4"
            text-color="green darken-4">Active</v-chip>
          <v-chip v-if="subscription.status === 'canceled'" label small color="red lighten-4"
            text-color="red darken-4">Canceled</v-chip>
        </v-col>
        <v-col cols="3" v-else class="text-right shrink">
          <v-skeleton-loader width="100" type="button"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="mt-2">
        <v-col>
          <div>
            <strong>Started</strong> <br />
            <span v-if="subscription">{{
              $moment.unix(subscription.start_date).format("LL")
            }}</span>
            <v-skeleton-loader width="75" v-else type="text"></v-skeleton-loader>
          </div>
          <div>
            <strong>Charge</strong> <br />
            <span v-if="subscription">{{ totalAmount | currency }} /
              {{ subscription.items.data[0].price.recurring.interval }}</span>
            <v-skeleton-loader v-else type="text"></v-skeleton-loader>
          </div>

          <div>
            <strong>Balance</strong> <br />
            <span v-if="customer">{{
              (customer.balance / 100) | currency
            }}</span>
            <v-skeleton-loader width="75" v-else type="text"></v-skeleton-loader>
          </div>
          <div>
            <strong>Attendees</strong> <br />
            <div v-if="subscription">
              <span v-if="subscription.status === 'canceled'">0</span>
              <span v-else>{{ totalEmployee }}</span>
            </div>

            <v-skeleton-loader width="50" v-else type="text"></v-skeleton-loader>
          </div>
        </v-col>
        <v-col>
          <div>
            <strong>Next invoice</strong> <br />
            <span v-if="upComingInvoice">
              <v-chip v-if="upComingInvoice === 'canceled'" label small color="gray lighten-4"
                text-color="gray darken-4">Canceled</v-chip>
              <span v-else>
                {{ (upComingInvoice.total / 100) | currency }} on
                {{ $moment.unix(upComingInvoice.created).format("LL") }}
              </span>
            </span>
            <v-skeleton-loader v-else type="text"></v-skeleton-loader>
          </div>
          <div>
            <strong>Current period</strong> <br />
            <span v-if="upComingInvoice">
              <v-chip v-if="upComingInvoice === 'canceled'" label small color="gray lighten-4"
                text-color="gray darken-4">Canceled</v-chip>
              <span v-else>
                {{
                  $moment.unix(upComingInvoice.period_start).format("LL")
                }}
                to
                {{ $moment.unix(upComingInvoice.period_end).format("LL") }}
              </span>
            </span>
            <v-skeleton-loader v-else type="text"></v-skeleton-loader>
          </div>
          <div>
            <strong>Payment Method</strong>
            <div v-if="defaultCard">
              <span>{{ defaultCard.brand }} ●●●● {{ defaultCard.last4 }}</span>
            </div>
            <v-skeleton-loader v-else type="text"></v-skeleton-loader>
          </div>
          <div>
            <strong>Location Code</strong> <br />
            <div v-if="Location">
              <span id="locationCode">{{ Location.code }}</span>
              <v-btn text icon color="primary" @click="copyCode" small>
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </div>

            <v-skeleton-loader width="50" v-else type="text"></v-skeleton-loader>
          </div>
        </v-col>
      </v-row>

      <div class="mb-3">
        <div class="title mt-5">Plan Detail</div>
        <v-card outlined class="mt-2" v-if="subscription">
          <v-list>
            <v-list-item two-line v-for="(item, index) in subscription.items.data" :key="index">
              <v-list-item-avatar color="primary">
                {{ item.quantity }}
              </v-list-item-avatar>
              <v-list-item-content class="text-capitalize">
                <v-list-item-title>
                  {{ item.price.metadata.package }} package</v-list-item-title>
                <v-list-item-subtitle>{{ item.price.nickname }}
                  {{ (item.price.unit_amount / 100) | currency }}
                  {{ item.price.recurring.interval }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action-text>
                {{
                  ((item.price.unit_amount * item.quantity) / 100) | currency
                }}
              </v-list-item-action-text>
            </v-list-item>
          </v-list>
        </v-card>

        <v-card outlined class="mt-2" v-else>
          <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
        </v-card>

        <div class="text-right mr-3 mt-2">
          <strong>Total</strong>
          <span class="ml-10">{{ totalAmount | currency }}</span>
        </div>
      </div>

      <!-- <v-divider></v-divider> -->

      <div class="title mt-5">Invoices</div>
      <v-card outlined class="mt-2">
        <v-list v-if="invoices">
          <v-list-item two-line v-for="(item, index) in invoices" :key="index">
            <v-list-item-content class="text-capitalize">
              <v-list-item-title>
                {{ item.number }}
                <v-chip label small color="green lighten-4" text-color="green darken-4">{{ item.status }}</v-chip>
              </v-list-item-title>
              <v-list-item-subtitle>{{
                $moment.unix(item.created).format("MMM DD HH:mm A")
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action-text>
              {{ (item.total / 100) | currency }}
            </v-list-item-action-text>
          </v-list-item>
        </v-list>
        <v-skeleton-loader class="mt-2" v-else type="list-item-two-line"></v-skeleton-loader>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import locationService from "@/modules/Location/service.js";
import UpdatePayment from "@/modules/Location/components/UpdatePayment.vue";
import settingsService from "@/modules/BackOffice/service.js";
import Cancel from "@/modules/Location/components/Cancel.vue";
import UpDateSubscription from "@/modules/Location/components/UpDateSubscription.vue";
import StartSubscription from "@/modules/Location/components/StartSubscription.vue";
import publicService from "@/api/public";

export default {
  name: "location",
  data() {
    return {
      planId: null,
      Location: null,
      subscription: null,
      locationId: null,
      invoices: null,
      upComingInvoice: null,
      defaultCardId: null,
      defaultCard: null,
      customer: null,
      foundCustomClockInProduct: false,
      totalEmployee: null,
    };
  },
  components: {
    UpdatePayment,
    Cancel,
    UpDateSubscription,
    StartSubscription,
  },
  async created() {
    // await this.getPlan();
    await this.getLocation();
    await this.loadSubscription();
    this.getUpcomingInvoice();
    this.loadInvoices();
    await this.getCustomer();
  },
  watch: {
    defaultCardId() {
      this.getCardById();
    },
    totalEmployee(val) {
      console.log('val', val)
      // if (val === 0) {
      //   console.log("no account found for custom clock in");
      //   this.$router.push({
      //     name: "no-subscription",
      //     params: {
      //       // subscription: this.subscription,
      //       location: this.Location,
      //       customer: this.customer,
      //     },
      //   });
      // }
    },
  },
  computed: {
    totalAmount() {
      let total = 0;
      if (this.subscription && this.subscription.items.data) {
        this.subscription.items.data.map((item) => {
          total += item.price.unit_amount * item.quantity;
        });
      }

      return total / 100;
    },
  },
  methods: {
    copyCode() {
      var copyText = document.getElementById("locationCode");
      console.log("copyText", copyText.innerHTML);

      navigator.clipboard.writeText(copyText.innerHTML);
      this.$toast.success("Location code was copy", { timeout: 2000 });
    },
    hardwareOrder() {
      this.$router.push({ path: `/backoffice/${this.Location.id}/hardware` });
    },
    getPlan() {
      publicService.GetPlans({ audience: "CUSTOMCLOCKIN" }).then((response) => {
        // console.log('responseresponse GetPlans', response)
        this.planId = response.data[0].planId;
      });
    },
    reload() {
      this.loadSubscription();
      this.getUpcomingInvoice();
      this.loadInvoices();
      this.getCustomer();
    },
    gotoHome() {
      this.$router.push({ path: "/backoffice" });
    },
    getLocation() {
      if (!this.$route.params || !this.$route.params.id) {
        return this.$router.push({ path: "/backoffice" });
      }

      const location = this.$route.params;
      this.locationId = this.$route.params.id;
      console.log("get id", this.$route.params);

      locationService.getById(location.id).then((response) => {
        this.Location = response.data;
      });
    },
    getCardById() {
      return settingsService.Billing.getCardById(this.defaultCardId)
        .then((response) => {
          console.log("getCardById", response.data);
          this.defaultCard = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadSubscription() {
      return locationService.Billing.getSubscription(this.locationId)
        .then(async (response) => {
          this.totalEmployee = 0
          // console.log("sub", response.data);
          await Promise.all(
            response.data.items.data.map((item) => {
              // console.log("test", item);
              // console.log("row", row.price.product, "===", this.planId);
              // if (row.price.product === this.planId) {
              //   this.foundCustomClockInProduct = true;
              // }
              console.log('item', item)
              let employeeCount = (item.price.nickname === '12 Attendees' ? 12 : 1)
              // if (item.nickname === '12 Attendees') {
              //   this.totalEmployee += (item.nickname === '12 Attendees' ? 12 : 1) * item.quantity
              // } else {
              //   this.totalEmployee = 0
              // }
              if (employeeCount) {
                this.totalEmployee +=
                  (item.price.nickname === '12 Attendees' ? 12 : 1) * item.quantity;
              } else {
                this.totalEmployee = 0;
              }
            })
          );

          this.subscription = response.data;
          if (this.subscription && this.subscription.default_source) {
            this.defaultCardId = this.subscription.default_source;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCustomer() {
      return settingsService.Billing.getCustomer()
        .then((response) => {
          console.log("customer response data", response.data);
          // Data comes straight from stripe and they model their data inside data
          this.customer = response.data;

          if (this.customer && this.customer.default_source) {
            this.defaultCardId = this.customer.default_source;
          }

          if (this.subscription && this.subscription.default_source) {
            this.defaultCardId = this.subscription.default_source;
          }
        })
        .catch((error) => {
          console.log('customer response', error);
          // this.$Progress.error();
        });
    },
    loadInvoices() {
      return locationService.Billing.getInvoiceListBySubscription(
        this.locationId
      )
        .then((response) => {
          console.log("invoices", response.data);
          this.invoices = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getUpcomingInvoice() {
      // const proration_date = Math.floor(Date.now() / 1000);
      return locationService
        .getUpcomingInvoice(this.locationId)
        .then((response) => {
          console.log(
            "getUpcomingInvoice",
            response.data.lines.data[0].amount / 100
          );
          this.upComingInvoice = response.data;
        })
        .catch((error) => {
          this.upComingInvoice = "canceled";
          console.log(error);
        });
    },
  },
};
</script>

<style scoped></style>